// Environment configuration
const ENV_CONFIG = {
  development: {
    // apiUrl: "http://localhost:3003/api",
    apiUrl: "https://store.zagsystems.org/api",
    consumedFeUrl: "http://127.0.0.1:3000",
    isProduction: false,
    isTest: false,
    isDevelopment: true,
  },
  test: {
    apiUrl: "https://teststore.zagsystems.org/api",
    consumedFeUrl: "https://teststore2.zagsystems.org",
    isProduction: false,
    isTest: true,
    isDevelopment: false,
  },
  production: {
    apiUrl: "https://store.zagsystems.org/api",
    consumedFeUrl: "https://store.zagsystems.org",
    isProduction: true,
    isTest: false,
    isDevelopment: false,
  },
};

// Determine current environment
const getCurrentEnvironment = () => {
  // Priority 1: Explicit REACT_APP_ENV
  if (process.env.REACT_APP_ENV) {
    const env = process.env.REACT_APP_ENV.toLowerCase();
    if (ENV_CONFIG[env]) {
      return env;
    }
  }

  // Priority 2: NODE_ENV for development
  if (process.env.NODE_ENV === "development") {
    return "development";
  }

  // Priority 3: Default to production for builds
  return "production";
};

// Get current environment
const currentEnv = getCurrentEnvironment();

// Get base configuration
const baseConfig = ENV_CONFIG[currentEnv];

// Override with explicit REACT_APP_API_URL if provided
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  return baseConfig.apiUrl;
};

// Export configuration
export const API = getApiUrl();
export const CONSUMED_FE_URL = baseConfig.consumedFeUrl;

export const config = {
  API,
  CONSUMED_FE_URL,
  environment: currentEnv,
  isProduction: baseConfig.isProduction,
  isTest: baseConfig.isTest,
  isDevelopment: baseConfig.isDevelopment,

  // Helper methods
  getApiUrl: () => API,
  getFeUrl: () => CONSUMED_FE_URL,

  // Debug info
  debug: {
    currentEnv,
    envVars: {
      REACT_APP_ENV: process.env.REACT_APP_ENV,
      REACT_APP_API_URL: process.env.REACT_APP_API_URL,
      NODE_ENV: process.env.NODE_ENV,
    },
  },
};

export default config;
